import { dataLayer } from '@/v2/utils/dataLayer';

export const propertyCardCtaDataLayerEvent = ({
  actionName,
  pageName,
}: {
  actionName: string;
  pageName: string;
}) =>
  dataLayer.userInteractionsEvent({
    category: 'CTA Click',
    action: `${actionName}`,
    label: `${pageName} page`,
  });

export const propertyCardViewAllOptionsDataLayerEvent = ({
  pageName,
}: {
  pageName: string;
}) =>
  dataLayer.userInteractionsEvent({
    category: 'CTA Click',
    action: 'View all options',
    label: `${pageName} page`,
  });

export const propertyCardViewPackageDetailsDataLayerEvent = ({
  pageName,
}: {
  pageName: string;
}) =>
  dataLayer.userInteractionsEvent({
    category: 'CTA Click',
    action: 'Deal details and terms',
    label: `${pageName} page`,
  });
